module.exports = __webpack_public_path__ + "static/media/student-img.6b0b2862.png";